var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLessThan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 3 5",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.601 3.012l1.8 1.548v-.972l-1.116-.972 1.116-.96V.672L.601 2.22v.792z",
    fill: "#456D45"
  })));
}
export default SvgLessThan;